import { render, staticRenderFns } from "./custom-dropdown-rows.vue?vue&type=template&id=0a4b5ac8&"
import script from "./custom-dropdown-rows.vue?vue&type=script&lang=ts&"
export * from "./custom-dropdown-rows.vue?vue&type=script&lang=ts&"
import style0 from "./custom-dropdown-rows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports